export default __webpack_public_path__ + "static/media/DO_logo.bc0edc36.svg";